import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setHasShownToast } from '../../utils/offline/offlineToastState'

export function ResetOfflineToastOnRouteChange() {
  const location = useLocation()

  useEffect(() => {
    setHasShownToast(false) // 👈 reset on route change
  }, [location.pathname])

  return null
}
